import React from 'react';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import useCurrentLanguage from '../../../core/languages/hooks/useCurrentLanguage';
import EventCity from '../../../eventCities/types/EventCity';
import City from '../../../cities/types/City';
import Event from '../../../events/types/Event';

type Props = {
    cityEvent: EventCity;
    event?: Event;
    city?: City;
    customer?: any;
    isPendingEvent: boolean;
    isPendingCity: boolean;
    isPendingDepartment: boolean;
};

const TransferRequestHeaderDetails: React.FC<Props> = ({
    cityEvent,
    event,
    city,
    isPendingEvent,
    isPendingCity,
}) => {
    const t = useTranslate();
    const languageCode = useCurrentLanguage();

    return (
        <>
            {/* Title */}
            <div className="w-full mt-2">
                {!isPendingEvent && !isPendingCity && event && city && cityEvent.startDate && (
                    <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900 dark:text-white mb-8">
                        {t('transfers.message.formTitle')} - {' '}
                        {`${event.initials} ${city.trName[languageCode]}`}
                    </h2>
                )}
            </div>
        </>
    );
};

export default TransferRequestHeaderDetails;
